(() => {
  if (window.__lioraVariantGallerySyncLoaded) return;
  window.__lioraVariantGallerySyncLoaded = true;

  const mediaIdFromVariant = (variant) =>
    variant?.featured_media?.id || variant?.featured_image?.id;

  const sectionIdFromPicker = (picker) => {
    const input = picker?.closest('[id^="shopify-section-"]')
      ?.querySelector('input[id^="update-variant-"]');
    return input?.id.replace('update-variant-', '') || '';
  };

  const mediaLooksLikeASwatch = (mediaElement) => {
    const image = mediaElement?.querySelector('img');
    const alt = [
      mediaElement?.getAttribute('aria-label'),
      image?.alt,
      image?.getAttribute('data-alt')
    ].filter(Boolean).join(' ');

    if (/\b(swatch|colour chip|color chip)\b/i.test(alt)) return true;

    const width = image?.naturalWidth || Number(image?.getAttribute('width'));
    const height = image?.naturalHeight || Number(image?.getAttribute('height'));
    return width > 0 && height > 0 && Math.abs(width / height - 1) < 0.04;
  };

  const clickThumbnail = (thumbnail) => {
    const trigger = thumbnail?.matches('button, a, [role="button"]')
      ? thumbnail
      : thumbnail?.querySelector('button, a, [role="button"]');

    (trigger || thumbnail)?.click();
  };

  const preferredModelThumbnail = (sectionId) => {
    const thumbnails = [
      ...document.querySelectorAll(`[id^="x-thumbnail-${sectionId}-"]`)
    ];
    return thumbnails.find((thumbnail) => !mediaLooksLikeASwatch(thumbnail));
  };

  const syncGallery = (variant, picker, attempt = 0) => {
    const mediaId = mediaIdFromVariant(variant);
    if (!mediaId) return;

    const sectionId = sectionIdFromPicker(picker);
    if (!sectionId) return;

    const thumbnail = document.getElementById(`x-thumbnail-${sectionId}-${mediaId}`)
      || document.querySelector(`[data-media-id="${sectionId}-${mediaId}"]`);

    if (!thumbnail) {
      if (attempt < 8) {
        window.setTimeout(() => syncGallery(variant, picker, attempt + 1), 150);
      }
      return;
    }

    if (mediaLooksLikeASwatch(thumbnail)) {
      // A swatch is a selection aid, not hero photography.
      // The theme moves to it automatically, so restore the first model photo.
      clickThumbnail(preferredModelThumbnail(sectionId));
      return;
    }

    clickThumbnail(thumbnail);
  };

  document.addEventListener('eurus:variant:change', (event) => {
    const picker = event.target?.closest?.('.x-variant-picker')
      || document.querySelector('.x-variant-picker');

    // Run after the theme's own variant handler has finished moving the gallery.
    window.setTimeout(() => syncGallery(event.detail?.variant, picker), 120);
  });
})();
